import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CreateOutputsCollectionComponent } from 'src/app/components/home/output-collections/actions/create-outputs-collection.component';
import { Permission } from 'src/app/constants/permission.constant';
import { EStateAsset } from 'src/app/models/products/asset';
import { ProductSearch } from 'src/app/models/products/product';
import { IPreference } from 'src/app/models/users/userProfile';
import { AuthService } from 'src/app/services/auth.service';
import { ProductsService } from 'src/app/services/products.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-product-search-item',
    templateUrl: './product-search-item.component.html',
    styleUrls: ['./product-search-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class ProductSearchItemComponent implements OnInit {
  @Input() data!: ProductSearch;
  @Input() filter: boolean = false;
  apiBase = environment.apiBase;
  eState = EStateAsset;
  isImageLoaded = false;
  currentConfigDate!: IPreference;
  Permission = Permission;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    public authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.authService.currentPreference.subscribe((res) => {
      this.currentConfigDate = res;
    });
  }

  onEdit() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`batches/${this.data.batchId}/products/${this.data.id}`]),
    );
    window.open(url, '_blank');
  }

  downloadAssets() {
    const dialogRef = this.dialog.open(CreateOutputsCollectionComponent, {
      data: {
        organizationId: this.data.organizationId,
        isBatch: false,
        productIds: [this.data.id],
      },
    });
  }

  getLinkImage(image: string) {
    if (!this.authService.hasPermission(Permission.PostAssetsPreRelease) && !this.data.releasedInCollection) {
      return 'assets/image-placeholder.jpg';
    }
    return ProductsService.getLinkImage(image);
  }
}
